'use client';

import { useEffect, useState } from 'react';
import { getConnectStatus } from './api';

type Props = {
  vendorUserId: string;
  refreshKey?: number;
};

export function ConnectSetupChecklist({ vendorUserId, refreshKey = 0 }: Props) {
  const [charges, setCharges] = useState<boolean | null>(null);
  const [payouts, setPayouts] = useState<boolean | null>(null);

  useEffect(() => {
    if (!vendorUserId) return;
    let cancelled = false;
    getConnectStatus(vendorUserId)
      .then((status) => {
        if (cancelled) return;
        setCharges(status.connectChargesEnabled);
        setPayouts(status.connectPayoutsEnabled);
      })
      .catch(() => {
        if (!cancelled) {
          setCharges(false);
          setPayouts(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [vendorUserId, refreshKey]);

  const mark = (on: boolean | null) => (on ? '✓' : '—');

  return (
    <ul className="vendor-onboarding__checklist">
      <li className={charges ? 'done' : ''}>Card payments enabled {mark(charges)}</li>
      <li className={payouts ? 'done' : ''}>Payouts enabled {mark(payouts)}</li>
    </ul>
  );
}
